import { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

import Utils from 'utils/utils';

import { Paths } from 'utils/constants';

import { LogoType } from 'componets/ui/LogoType';

export const AccountLayoutLogoLink: FC<{ className: any }> = ({ className }) => {
	const location = useLocation();

	const isOverview = location.pathname === Paths.OVERVIEW;

	return isOverview ? (
		<a href={Utils.getLinkToWP('')} className={className}>
			<LogoType />
		</a>
	) : (
		<Link to={Paths.OVERVIEW} className={className}>
			<LogoType />
		</Link>
	);
};
